import React from "react";
import { Link } from 'react-router-dom';
import Skeleton from '@material-ui/lab/Skeleton';

function SubMenu(props) {
  return (
    <div className="Submenu">
      <div className="container">
        <ul className="list-inline m-0 p-0 d-flex flex-wrap justify-content-center">
            <li><Link className="py-2 "><Skeleton variant="text"/></Link></li>
            <li><Link className="py-2 "><Skeleton variant="text" /></Link></li>
            <li><Link className="py-2 "><Skeleton variant="text" /></Link></li>
            <li><Link className="py-2 "><Skeleton variant="text" /></Link></li>
        </ul>
      </div>
    </div>
  );
}

export default SubMenu;

